const MESSAGE_TYPES = {
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  INFO: 'info',
};

class Message {
  constructor(type, contents) {
    this.type = type;
    this.contents = contents;
  }
}

class SuccessMessage extends Message {
  constructor(contents) {
    super(MESSAGE_TYPES.SUCCESS, contents);
  }
}

class WarningMessage extends Message {
  constructor(contents) {
    super(MESSAGE_TYPES.WARNING, contents);
  }
}

class ErrorMessage extends Message {
  constructor(contents) {
    super(MESSAGE_TYPES.ERROR, contents);
  }
}

class InfoMessage extends Message {
  constructor(contents) {
    super(MESSAGE_TYPES.INFO, contents);
  }
}

export default InfoMessage;
export {
  SuccessMessage,
  WarningMessage,
  ErrorMessage,
};
